
import axiosMiddleware from './axiosMiddleware'
import env from '../config/env'

const verifyOTP = async (params) => axiosMiddleware(env.BACKEND_END_POINT).post('/VerifyOTP', params)

export default verifyOTP
